"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilIconTaskDone = void 0;
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var utils_1 = require("../utils");
var StatusDone = function (props) { return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM18.15 7.74998C17.75 7.34998 17.15 7.39998 16.75 7.79998L10.35 14.65L7.6 12.25C7.2 11.9 6.55 11.95 6.2 12.35C5.85 12.75 5.9 13.4 6.3 13.75L9.8 16.75C10.2 17.1 10.85 17.05 11.2 16.65L18.2 9.14998C18.6 8.74998 18.55 8.14998 18.15 7.74998Z" }))); };
exports.UtilIconTaskDone = (0, utils_1.withDeprecationWarning)(StatusDone, 'UtilIconTaskDone');
exports.default = StatusDone;
